module.exports = __webpack_public_path__ + "static/media/Decisions_Step1_Image11.ea0cf1c8.webp";